<template>
<div>
    <h1 class="mb-3">Vaccination Centre Details</h1>

    <table class="table table-bordered table-sm">
        <colgroup>
            <col width="250">
            <col>
        </colgroup>
        <tr>
            <th colspan="2" class="text-uppercase">General Info</th>
        </tr>
        <tr>
            <th>Name</th>
            <td>{{name}}</td>
        </tr>
        <tr>
            <th>Email Address</th>
            <td>{{email}}</td>
        </tr>
        <tr>
            <th>Phone Number</th>
            <td>{{phone}}</td>
        </tr>
    </table>

    <table class="table table-bordered table-sm">
        <colgroup>
            <col width="250">
            <col>
        </colgroup>
        <tr>
            <th colspan="2" class="text-uppercase">Location Info</th>
        </tr>
        <tr>
            <th>Region</th>
            <td>{{region}}</td>
        </tr>
        <tr>
            <th>Address</th>
            <td>{{`${(address2 ? address1 + ', ' + address2 : address1)}, ${city}, ${postcode} ${state}`}}</td>
        </tr>
    </table>

    <table class="table table-bordered table-sm">
        <colgroup>
            <col width="250">
            <col>
        </colgroup>
        <tr>
            <th colspan="2" class="text-uppercase">Bank Details</th>
        </tr>
        <tr>
            <th>Bank Payee Name</th>
            <td>
                {{bankAccountPayeeName}}
            </td>
        </tr>
        <tr>
            <th>Bank Name</th>
            <td>
                {{bankName}}
            </td>
        </tr>
        <tr>
            <th>Bank Account Number</th>
            <td>
                {{bankAccountNumber}}
            </td>
        </tr>
    </table>

</div>
</template>

<script>
import popupModal from '@/components/popup-modal';
export default {
    'name': 'VaccinationCentreProfile',
    'components': {
        popupModal
    },
    'computed': {
        id () {
            return this.$route.params.id;
        }
    },
    data () {
        return {
            'name': '',
            'phone': '',
            'email': '',
            'region': '',
            'address1': '',
            'address2': '',
            'city': '',
            'state': '',
            'postcode': '',
            'bankAccountPayeeName': '',
            'bankName': '',
            'bankAccountNumber': ''
        };
    },

    'methods': {
        getDetails () {
            this.axios.get(`VaccinationCentre?vaccinationCentreId=${this.id}`).then((response) => {
                this.name = response.data.data.n;
                this.phone = response.data.data.ph;
                this.email = response.data.data.e;
                this.region = response.data.data.rn;
                this.address1 = response.data.data.a1;
                this.address2 = response.data.data.a2;
                this.city = response.data.data.ac;
                this.state = response.data.data.as;
                this.postcode = response.data.data.ap;
                this.bankAccountPayeeName = response.data.data.bapn;
                this.bankName = response.data.data.bn;
                this.bankAccountNumber = response.data.data.ban;
            });
        }
    },

    mounted () {
        this.getDetails();
    }
};
</script>

<style>

</style>
